import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热门专题</h2>
          <p className="text-sm text-foreground-500 mb-8">精选韩漫日漫国漫专题合集，发现你的下一部最爱</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {carouselItems.map((item, i) => (
              <a
                key={i}
                href="#carousel"
                className="group block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading={i >= 3 ? 'lazy' : undefined}
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-background-50/90 text-primary-600 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 mt-1.5 line-clamp-2">{item.desc}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}